export const formatZipCode = (data: string) =>
  data.replace(/\D/g, '').replace(/(\d{5})(\d{3})(.?)/, '$1-$2');

export const zipCodeIsValid = (zipCode: string) =>
  /^(\d{5})-(\d{3})$/.test(zipCode);
